<template>
  <vs-dropdown
    vs-custom-content
    vs-trigger-click
    class="cursor-pointer">

    <feather-icon
      icon="ShoppingCartIcon"
      class="cursor-pointer mt-1 mr-1 sm:mr-3"/>

    <vs-dropdown-menu class="vx-navbar-dropdown">
      <ul style="min-width: 9rem">
        <li
          class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
          @click="$router.push('/settings/prepaid-packages').catch(() => {})">
          <feather-icon
            icon="BoxIcon"
            svgClasses="w-4 h-4" />
          <span class="ml-2">{{ $t('PrepaidPackages') }}</span>
        </li>

        <li
          class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
          @click="$router.push('/settings/dedicated-numbers').catch(() => {})">
          <feather-icon
            icon="PhoneIcon"
            svgClasses="w-4 h-4" />
          <span class="ml-2">{{ $t('DedicatedNumbers') }}</span>
        </li>

        <li
          class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
          @click="$router.push('/settings/auto-top-up').catch(() => {})">
          <feather-icon
            icon="DollarSignIcon"
            svgClasses="w-4 h-4" />
          <span class="ml-2">{{ $t('AutoTopUp') }}</span>
        </li>
      </ul>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

  <script>
  export default {
    name: 'PurchaseButton',
    i18n: {
      messages: {
        en: {
          PrepaidPackages: 'Prepaid packages',
          DedicatedNumbers: 'Dedicated numbers',
          AutoTopUp: 'Auto top-up',
        },
      },
    },
  };
  </script>

